/**
 * Encodes only the characters that break query-string parsing (`+ & = # ?`) in a
 * taxonomy `path` value, leaving `/` and `-` readable. `encodeURIComponent` would
 * additionally encode the path separators and mangle the path.
 */
export const encodePathQueryParam = (path: string): string =>
  path.replace(/[+&=#?]/g, (char) => encodeURIComponent(char));
